var React = require('react');

function ChevronDownInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 24) rotate(-90)"},[React.createElement("path",{"id":"Path_212","data-name":"Path 212","d":"M0,0H24V24H0Z","fill":"none","key":0}),React.createElement("path",{"id":"Path_213","data-name":"Path 213","d":"M15.41,7.41,14,6,8,12l6,6,1.41-1.41L10.83,12Z","fill":"#1a1b21","key":1})]));
}

ChevronDownInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ChevronDownInline;

ChevronDownInline.default = ChevronDownInline;
